import { LookupData } from "./types";

export function filter(searchTerm: string, lookupData: LookupData[]): LookupData[] {
  const isMatch = (name: string) => name.toLowerCase().includes(searchTerm.toLowerCase());
  return lookupData.filter((x) => isMatch(x.name));
}
